import { PolicyUsage } from "@covertree/new-business-graphql";
import { HomeUsage, OwnershipType, ResidencyType } from "@covertree/types";

export const getPolicyUsage = (
  ownershipType: OwnershipType,
  residencyType: ResidencyType,
  homeUsage: HomeUsage
): PolicyUsage => {
  if (ownershipType === OwnershipType.Landlord) {
    return PolicyUsage.Rental;
  }

  if (residencyType === ResidencyType.Tenant) {
    return PolicyUsage.Tenant;
  }

  if (homeUsage === HomeUsage.MainResidence) {
    return PolicyUsage.Owner;
  }

  if (homeUsage === HomeUsage.SeasonalResidence) {
    return PolicyUsage.Seasonal;
  }

  if (homeUsage === HomeUsage.HomeIsVacant) {
    return PolicyUsage.Vacant;
  }

  throw new Error("Incorrect Policy Usage supplied");
};
